module.exports = {"549":"https://datayi.cn/oeRDpKq"}


//////////////////
// WEBPACK FOOTER
// ./src/config/appInterIkeaPromotion.json
// module id = PTZd
// module chunks = 7